import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutateFunction,
} from 'react-query'

import { type SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'
import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { catalogAccessRepository } from '@webapp/modules/purchasing/data-access/repositories/CatalogAccessRepository'
import { catalogAccessQueryConfig } from '@webapp/modules/purchasing/query-configs/catalogAccess'

interface SaveUserGrantsPayload {
  userId: number
  secondaryCategoryIds: number[]
}

interface UseAssignSecondaryCategoriesToUserModelReturn {
  mutate: UseMutateFunction<void, RepoError, SaveUserGrantsPayload>
  isLoading: boolean
  isOptionsLoading: boolean
  secondaryCategoryOptions: SecondaryCategory[]
}

export const useAssignSecondaryCategoriesToUserModel =
  (): UseAssignSecondaryCategoriesToUserModelReturn => {
    const queryClient = useQueryClient()

    const { data: formDefaults, isLoading: isOptionsLoading } = useQuery(
      catalogAccessQueryConfig.userAccessFormDefaults()
    )

    const secondaryCategoryOptions =
      formDefaults?.secondaryCategoryOptions ?? []

    const { mutate, isLoading } = useMutation<
      void,
      RepoError,
      SaveUserGrantsPayload
    >({
      mutationFn: ({ userId, secondaryCategoryIds }: SaveUserGrantsPayload) =>
        catalogAccessRepository.saveUserGrants(userId, secondaryCategoryIds),
      onSuccess: () => {
        queryClient.invalidateQueries(
          catalogAccessQueryConfig.userConfigs().queryKey
        )
      },
    })

    return {
      mutate,
      isLoading,
      isOptionsLoading,
      secondaryCategoryOptions,
    }
  }
